export default __webpack_public_path__ + "static/media/lisnr-point-icon-white.63050ce3.svg";